module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "vsm-item mobile-item",
    class: [{
      'open-item': _vm.item.child
    }, {
      'active-item': _vm.active
    }, {
      'parent-active-item': _vm.childActive
    }]
  }, [(!_vm.item.child) ? [(_vm.isRouterLink) ? _c('router-link', {
    staticClass: "vsm-link",
    attrs: {
      "to": {
        name: _vm.item.href
      },
      "disabled": _vm.item.disabled,
      "event": _vm.item.disabled ? '' : 'click'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickEvent.apply(null, arguments)
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.title) + "\n        ")]) : _c('a', {
    staticClass: "vsm-link",
    attrs: {
      "href": _vm.item.href,
      "disabled": _vm.item.disabled
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.title) + "\n        ")])] : [_c('div', {
    staticClass: "vsm-link"
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.title) + "\n            "), _c('i', {
    staticClass: "vsm-arrow open-arrow"
  })])]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cf3ae0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/MobileItem.vue
// module id = nC6b
// module chunks = 36